import { render } from "./AppFormView_22000.vue?vue&type=template&id=4036f89a&scoped=true"
import script from "./AppFormView_22000.vue?vue&type=script&lang=js"
export * from "./AppFormView_22000.vue?vue&type=script&lang=js"

import "./AppFormView_22000.vue?vue&type=style&index=0&id=4036f89a&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4036f89a"]])

export default __exports__